export default "__VITE_ASSET__CRW4kosH__"